import { Link } from "@chakra-ui/react"
import React from "react"
import { useSettings } from "~/hooks/useSettings"
import { useCookieConsentReopen } from "./hooks/useCookieConsentReopen"

interface Props {
  id: string
  label: string
}

// reopens the cookie consent prompt, hidden when the prompt is disabled
const CookieConsentLink: React.FC<Props> = ({ id, label }) => {
  const { settings } = useSettings()
  const { open } = useCookieConsentReopen()

  if (!settings.isCookieConsentPromptEnabled) {
    return null
  }

  return (
    <Link
      as="button"
      id={id}
      textAlign="left"
      _hover={{ textDecoration: "underline" }}
      onClick={open}
    >
      {label}
    </Link>
  )
}

export default CookieConsentLink
